export default function() {
  return new Worker(__webpack_public_path__ + "pdf.worker.entry-698334e626d5cdf9eb84.worker.js");
}
